import { getPreviousDate, stringToDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { stockChangesCurrentPeriod, stockChangesEndDate } from "../@signals"


export const stockChangesDateRange = [
    {
        label: "Yesterday",
        value: () => { return [getPreviousDate({ days: 1 }, stockChangesEndDate.value), getPreviousDate({ days: 1 }, stockChangesEndDate.value)]},
        placement: "left",
        onFocus: () => stockChangesCurrentPeriod.value = DATE_PERIODS.YESTERDAY
    }, {
        label: "Last 7 Days",
        value: () => { return [getPreviousDate({ days: 6 }, stockChangesEndDate.value), stringToDate(stockChangesEndDate.value)]},
        placement: "left",
        onFocus: () => stockChangesCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS
    }, {
        label: "Last 30 Days",
        value: () => { return [getPreviousDate({ days: 29 }, stockChangesEndDate.value), stringToDate(stockChangesEndDate.value)]},
        placement: 'left',
        onFocus: () => stockChangesCurrentPeriod.value = DATE_PERIODS.LAST_30_DAYS
    }, {
        label: "Last Month",
        value: () => {
            return [
                getPreviousDate({ months: 1 }, new Date(stringToDate(stockChangesEndDate.value).setDate(1))),
                getPreviousDate({ days: 1 },  new Date(stringToDate(stockChangesEndDate.value).setDate(1)))
            ]
        },
        placement: "left",
        onFocus: () => stockChangesCurrentPeriod.value = DATE_PERIODS.LAST_MONTH
    }
]